// extracted by mini-css-extract-plugin
export var clickThrough = "_yj-2";
export var fallback = "_yj-5";
export var frame = "_yj-3";
export var frameCell = "_yj-1";
export var overlay = "_yj-4";
export var wrapper = "_yj-0";